// Learn article enhancements: table of contents, reading progress,
// scrollable tables, code copy buttons and copy-link.
(() => {
  const article = document.querySelector('.ma');
  if (!article) return;
  const body = article.querySelector('.ma-body');
  if (!body) return;

  const slugify = (text) =>
    text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .slice(0, 80) || 'section';

  // Table of contents from h2/h3.
  const toc = article.querySelector('.ma-toc');
  const headings = Array.from(body.querySelectorAll('h2, h3')).filter((h) => h.textContent.trim());
  if (toc && headings.length >= 3) {
    const list = toc.querySelector('.ma-toc__list');
    const used = new Set();
    const links = headings.map((h) => {
      if (!h.id) {
        let id = slugify(h.textContent);
        let n = 2;
        while (used.has(id) || document.getElementById(id)) id = `${slugify(h.textContent)}-${n++}`;
        h.id = id;
      }
      used.add(h.id);
      const li = document.createElement('li');
      if (h.tagName === 'H3') li.className = 'ma-toc__sub';
      const a = document.createElement('a');
      a.href = `#${h.id}`;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
      return a;
    });
    toc.hidden = false;

    // Collapse on small screens so it doesn't push the article down.
    const details = toc.querySelector('details');
    if (details && window.matchMedia('(max-width: 1099px)').matches) details.open = false;

    if ('IntersectionObserver' in window) {
      const byId = new Map(links.map((a) => [a.hash.slice(1), a]));
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            links.forEach((a) => a.removeAttribute('aria-current'));
            const active = byId.get(entry.target.id);
            if (active) active.setAttribute('aria-current', 'true');
          });
        },
        { rootMargin: '-15% 0px -70% 0px' }
      );
      headings.forEach((h) => observer.observe(h));
    }
  } else if (toc) {
    toc.remove();
    article.querySelector('.ma-layout')?.classList.remove('ma-layout--toc');
  }

  // Wide tables scroll inside their own box instead of breaking the layout.
  body.querySelectorAll('table').forEach((table) => {
    if (table.parentElement.classList.contains('ma-table')) return;
    const wrap = document.createElement('div');
    wrap.className = 'ma-table';
    wrap.tabIndex = 0;
    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(table);
  });

  // Lazy-load in-article images below the cover.
  body.querySelectorAll('img').forEach((img) => {
    if (!img.hasAttribute('loading')) img.loading = 'lazy';
    img.decoding = 'async';
  });

  const copy = async (text, button, label) => {
    try {
      await navigator.clipboard.writeText(text);
      button.textContent = 'Copied';
    } catch (e) {
      button.textContent = 'Press Ctrl+C';
    }
    setTimeout(() => (button.textContent = label), 1600);
  };

  // Copy buttons on code blocks.
  body.querySelectorAll('pre').forEach((pre) => {
    const text = pre.innerText;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ma-code-copy';
    button.textContent = 'Copy';
    button.addEventListener('click', () => copy(text, button, 'Copy'));
    pre.appendChild(button);
  });

  const shareButton = article.querySelector('.ma-copy-link');
  if (shareButton) {
    shareButton.addEventListener('click', () => copy(shareButton.dataset.url || location.href, shareButton, 'Copy link'));
  }

  // Reading progress.
  const bar = document.querySelector('.ma-progress');
  if (bar) {
    let ticking = false;
    const update = () => {
      const rect = body.getBoundingClientRect();
      const total = rect.height - window.innerHeight * 0.6;
      const progress = Math.min(1, Math.max(0, -rect.top / (total || 1)));
      bar.style.setProperty('--ma-progress', progress.toFixed(4));
      ticking = false;
    };
    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    update();
  }
})();
